import { createApp } from 'vue'
import ZlModal from '../layouts/ZlModal.vue'

// 创建模态框实例
const createModalInstance = (options = {}) => {
  return new Promise((resolve) => {
    // 创建容器
    const modalContainer = document.createElement('div')
    modalContainer.className = 'zl-modal-container'
    document.body.appendChild(modalContainer)

    // 创建Vue应用实例
    const modalOptions = {
      ...options,
      onOk: () => {
        if (options.onOk) {
          options.onOk()
        }
        instance.destroy()
        resolve(true)
      },
      onCancel: () => {
        if (options.onCancel) {
          options.onCancel()
        }
        instance.destroy()
        resolve(false)
      },
      onClose: () => {
        if (options.onClose) {
          options.onClose()
        }
        instance.destroy()
        resolve(false)
      }
    }

    const app = createApp(ZlModal, modalOptions)
    const instance = app.mount(modalContainer)
    
    // 添加销毁方法
    instance.destroy = () => {
      app.unmount()
      if (modalContainer && modalContainer.parentNode) {
        modalContainer.parentNode.removeChild(modalContainer)
      }
    }
  })
}

// 模态框工具类
const modal = {
  // 通用显示方法
  show(options = {}) {
    return createModalInstance({
      visible: true,
      ...options
    })
  },

  // 信息模态框
  info(options = {}) {
    return createModalInstance({
      visible: true,
      type: 'info',
      title: '信息',
      showCancel: false,
      ...options
    })
  },

  // 成功模态框
  success(options = {}) {
    return createModalInstance({
      visible: true,
      type: 'success',
      title: '成功',
      showCancel: false,
      ...options
    })
  },

  // 警告模态框
  warning(options = {}) {
    return createModalInstance({
      visible: true,
      type: 'warning',
      title: '警告',
      showCancel: false,
      ...options
    })
  },

  // 错误模态框
  error(options = {}) {
    return createModalInstance({
      visible: true,
      type: 'error',
      title: '错误',
      showCancel: false,
      ...options
    })
  },

  // 确认模态框
  confirm(options = {}) {
    return createModalInstance({
      visible: true,
      type: 'confirm',
      title: '确认',
      showCancel: true,
      ...options
    })
  }
}

// Vue插件安装方法
export const ZlModalPlugin = {
  install(app) {
    // 全局属性
    app.config.globalProperties.$modal = modal
    
    // 提供注入
    app.provide('$modal', modal)
  }
}

// 导出模态框工具类
export { modal }

// 默认导出
export default modal